export default "__VITE_ASSET__Bu$9tlDK__"